import { render, staticRenderFns } from "./ibTabs.vue?vue&type=template&id=c410b6d2&scoped=true"
import script from "./ibTabs.vue?vue&type=script&lang=js"
export * from "./ibTabs.vue?vue&type=script&lang=js"
import style0 from "./ibTabs.vue?vue&type=style&index=0&id=c410b6d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c410b6d2",
  null
  
)

export default component.exports